import { styled as e } from "styled-components";
//#region src/components/AppFooter/AppFooter.styled.ts
var t = e.footer`
    background-color: ${({ theme: e }) => e.colors.secondary};
    border-top: 1px solid ${({ theme: e }) => e.colors.border};
    padding: ${({ theme: e }) => e.spacing(6)} 0 ${({ theme: e }) => e.spacing(3)};
    color: ${({ theme: e }) => e.colors.foreground};
`, n = e.div`
    max-width: 1520px;
    margin: 0 auto;
    width: 100%;
    padding: 0 ${({ theme: e }) => e.spacing(3)};

    @media (max-width: 640px) {
        padding: 0 ${({ theme: e }) => e.spacing(2)};
    }
`, r = e.a`
    color: ${({ theme: e }) => e.colors.foreground};
    text-decoration: none;
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    transition: color ${({ theme: e }) => e.transitions.fast};

    &:hover {
        text-decoration: underline;
    }
`, i = e.div`
    margin-bottom: ${({ theme: e }) => e.spacing(1)};
`, a = e.div`
    border-top: 1px solid ${({ theme: e }) => e.colors.border};
    margin: ${({ theme: e }) => e.spacing(4)} 0;
`, o = e.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: ${({ theme: e }) => e.spacing(2)};

    @media (max-width: 800px) {
        flex-direction: column-reverse;
        align-items: flex-start;
        gap: ${({ theme: e }) => e.spacing(3)};
    }
`, s = e.a`
    color: ${({ theme: e }) => e.colors.foreground};
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        opacity: 0.8;
    }
`, c = e.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: ${({ theme: e }) => e.spacing(4)};

    @media (min-width: 768px) {
        grid-template-columns: repeat(3, 1fr);
    }
`;
//#endregion
export { a as BottomBorder, o as BottomSection, n as Container, c as FooterGrid, r as FooterLinkStyled, t as FooterWrapper, i as SectionTitle, s as SocialLink };
